import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustedBy } from "@/components/TrustedBy";
import { Experience } from "@/components/Experience";
import { Services } from "@/components/Services";
import { WhyGoodShot } from "@/components/WhyGoodShot";
import { Volume } from "@/components/Volume";
import { EventsWeServe } from "@/components/EventsWeServe";
import { UseCases } from "@/components/UseCases";
import { Process } from "@/components/Process";
import { Portfolio } from "@/components/Portfolio";
import { Founder } from "@/components/Founder";
import { InquiryForm } from "@/components/InquiryForm";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-[#050505] text-white antialiased grain overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <TrustedBy />
        <Experience />
        <Services />
        <WhyGoodShot />
        <Volume />
        <EventsWeServe />
        <UseCases />
        <Process />
        <Portfolio />
        <Founder />
        <InquiryForm />
      </main>
      <Footer />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
